<template>
  <b-row>
    <b-col cols="10">
      {{ description }}
    </b-col>
    <b-col>
      <b-row>
        <b-col>
          <b-link>
            Website
          </b-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-link>
            Support
          </b-link>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "MyApp_DetailView_Description",
  components: {},
  props: {
    tool: {
      type: Object,
      default: () => {return {}}
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    handleWebsiteClick(){
      window.open(this.websiteURL, "_blank");
    },
    handleSupportClick() {
      window.open(this.supportURL, "_blank");
    }
  },
  data() {
    return {
      name: this.tool ? this.tool.name: '',
      description: this.tool ? this.tool.description: '',
      companyName: this.tool && this.tool.company ? this.tool.company.name: '',
      websiteURL: `https://d3rriana.com/myapps/${this.name}`,
      supportURL: `https://d3rriana.com/myapps/${this.name}/support`,

    }
  }
}
</script>
<style lang="scss" scoped></style>
